import React from 'react';
import icons from './../../icons.svg';

const RefillPlanFeedback = ({ t, severity, icon, message }) => {
  return (
    <div className="inventory-info">
      <svg className={severity}>
        <use xlinkHref={`${icons}#${icon}`} />
      </svg>
      <span>{t(message)}</span>
    </div>
  );
};

export default RefillPlanFeedback;
